import { defineStore } from "pinia"

interface Growl {
  id?: number;
  title: string;
  content: string;
  type: 'success' | 'danger' | 'info' | 'warning';
  duration?: number;
}

interface State {
  growls: Growl[];
  nextId: number
}


export const useGrowlStore = defineStore({
  id: "growl",
  state: (): State => ({
    growls: [] as Growl[],
    nextId: 1,
  }),
  getters: {
    activeGrowls: (state) => state.growls,
  },
  // Modal store actions
  actions: {
    open({ type, title, content, duration = 5000 }: Growl) {
      const id = this.nextId++;
      this.growls.push({ id, type, title, content, duration });
      setTimeout(() => this.close(id), duration);
    },

    close(id?: number) {
      this.growls = this.growls.filter((growl) => growl.id !== id);
      this.nextId = 1
    },
  },
})

export const GROWL_TYPE_SUCCESS = "success";
export const GROWL_TYPE_DANGER = "danger";
export const GROWL_TYPE_INFO = "info";
export const GROWL_TYPE_WARNING = "warning";
